import abilitiesData from '../../../../config/static_data/abilities.json'
import encounterTimelineData from '../../../../config/static_data/encounter_timeline_v2.json'
import { generalTimelineAbilities } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamPlans/config/generalAbilities'
import { Abilities } from 'app/frontend/types/custom/Abilities'
import { AbilitySpell } from 'app/frontend/types/custom/Abilities'
import { EncounterEvents } from 'app/frontend/types/custom/EncounterEvents'

const abilities = abilitiesData as Abilities
const encounterTimeline = encounterTimelineData as unknown as EncounterEvents
const timelineSpellsById = [
  ...Object.values(abilities.classSpells),
  ...Object.values(abilities.specSpells),
  generalTimelineAbilities,
]
  .flat()
  .reduce<Record<number, AbilitySpell>>((acc, spell) => {
    acc[spell.id] = spell
    return acc
  }, {})
const timelineSpellNameById = Object.entries(timelineSpellsById).reduce<
  Record<number, string>
>((acc, [spellId, spell]) => {
  acc[Number(spellId)] = spell.name
  return acc
}, {})

export const getRaidPlanAbilities = () => abilities
export const getEncounterTimelineData = () => encounterTimeline
export const getGeneralTimelineAbilities = () => generalTimelineAbilities
export const getTimelineSpellsById = () => timelineSpellsById
export const getTimelineSpellNameById = () => timelineSpellNameById
